import React from 'react';
import classNames from 'classnames';

import { AppStateComponent } from 'src/AppState/AppState';
import { observer } from 'mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { TypeId } from 'src_common/common/websocket2/type';

interface PropsType {
    className?: string,
    userId: number,
    marketId: TypeId.MarketId,
    selectionId: number,
    allowShowSp?: boolean,
    onHoverSelection?: () => void,
    children?: React.ReactNode,
    name?: string,
}

@observer
class Selection extends AppStateComponent<PropsType> {
    choose(marketModel: MarketModel, selection: SelectionModel) {
        return (e: React.MouseEvent<HTMLButtonElement>): void => {
            const { userId, selectionId } = this.props;
            const selected = this.appState.reduxBetslipSelectedLeg.isSelected(userId, selectionId);

            e.stopPropagation();
            e.preventDefault();

            if (selected) {
                this.appState.reduxAction.onBetslipRemoveLeg(userId, marketModel, selection);
            } else {
                this.appState.reduxAction.onBetslipAddLeg(userId, marketModel, selection);
            }
        };
    }

    onHover(e: React.MouseEvent<HTMLButtonElement>): void {
        const { onHoverSelection } = this.props;

        e.stopPropagation();
        e.preventDefault();

        if (onHoverSelection) {
            onHoverSelection();
        }
    }

    render(): React.ReactElement | null {
        const { className, userId, marketId, selectionId, name } = this.props;
        const selected = this.appState.reduxBetslipSelectedLeg.isSelected(userId, selectionId);

        const selectionModel = this.appState.getSelection(marketId, selectionId);

        if (selectionModel === null) {
            return null;
        }

        if (selectionModel.resultType === 'void') {
            return <span key={`${selectionModel.id}-non-runner`} className='main-market-column__selection main-market-column__selection--not-running'>NR</span>;
        }
        if (!selectionModel.display) {
            return <span key={`${selectionModel.id}-shown-false`} className='main-market-column__selection'>-</span>;
        }

        const marketModel = selectionModel.getMarket();
        if (marketModel === null) {
            return null;
        }

        const priceChange = selectionModel.forView()?.priceChange ?? null;

        const price = selectionModel.price ?? (this.showSp(selectionModel) ? 'SP' : undefined);
        const suspended = !selectionModel.activated;

        const classNameJsx = classNames([
            className,
            'selection',
            { 'selection--selected': selected },
            { 'selection--suspended': suspended },
            { 'selection--up': priceChange === 'up' },
            { 'selection--down': priceChange === 'down' },
            { 'selection--noprice': price === undefined }
        ]);


        if (this.props.children) {
            return (
                <button type='button' className={ classNameJsx } onClick={ this.choose(marketModel, selectionModel) } onMouseOver={ this.onHover.bind(this) }>
                    { this.props.children }
                </button>
            );
        }

        return (
            <button className={ classNameJsx } onClick={ this.choose(marketModel, selectionModel) } onMouseOver={ this.onHover.bind(this) }>
                {`${ price === 'SP' ? 'SP' : price === undefined ? '' : price.f } ${name ?? ''}`}
            </button>
        );
    }

    showSp(selection: SelectionModel): boolean {
        const { allowShowSp } = this.props;

        if (allowShowSp !== true) {
            return false;
        }

        if (selection.templateId === 'unnamed-favourite') {
            return true;
        }

        if (selection.getMarket()?.sp === true) {
            return true;
        }

        return false;
    }
}

export default Selection;
